export default {
  SET_LOADING(state, status) {
    state.loading = status;
  },

  SET_REVIEWS_DATA(state, data) {
    state.data = data;
  },

  SET_REVIEWS(state, reviews) {
    state.data.results = reviews;
  },

  SET_REPLIED_REVIEW(state, data) {
    state.data.results = state.data.results.map(item => {
      if (item.id === data.id) {
        return { ...item, ...data };
      }
      return item;
    });
  },

  DELETE_REPLIED_REVIEW(state, id) {
    state.data.results = state.data.results.map(item => {
      if (item.id === id) {
        item.reply_comment = null;
        return item;
      }
      return item;
    });
  },

  SET_SELECTED_ITEMS(state, data) {
    state.selectedItems = data;
  },

  SET_ALL_REVIEWS_TOTAL_COUNT(state, data) {
    state.allReviewsTotalCount = data;
  },

  SET_ALL_ITEMS_SELECTED(state, data) {
    state.allItemsSelected = data;
  },

  SET_IS_AI_REPLY_IN_PROGRESS(state, data) {
    state.isAiReplyInProgress = data;
  }
};
